import React from 'react';
import {makeStyles} from '@material-ui/core';
import LocationsContentBar from '../../../contents/location/LocationsContentBar';
import clsx from 'clsx';
import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';
import {getActualMenu} from 'shared/src/helpers/menuHelper';
import {MENU} from 'shared';
import {useSelector} from 'react-redux';

const useStyles = makeStyles(theme => ({
    layout: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '32px',
        [theme.breakpoints.up('lg')]: {
            justifyContent: 'space-between',
            flexDirection: 'row',
            marginBottom: '0px',
        }
    },
    wrapper: {
        width: '100%',
    },
    title: {
        margin: '32px 0px 24px 0px',
    },
    tabletPadding: {
        paddingLeft: '32px',
        paddingRight: '32px',
    }
}));

export default function MainMenuPopoverLocations() {
    const classes = useStyles();

    const isTablet = useMediaQuery(theme => theme.breakpoints.up('sm'));
    const isDesktop = useMediaQuery(theme => theme.breakpoints.up('lg'));

    const menus = useSelector(state => state.menu.menus);
    const user = useSelector(state => state.user.user);

    const menu = getActualMenu(menus, MENU.TYPES_ANP.ANP_MENU_MAIN, user);
    const locationsMenu = menu.find(menuItem => menuItem.index === MENU.MAIN_MENU_ANP.LOCATION);

    return (
        <div className={clsx(isDesktop && 'padding', classes.layout)}>
            <div
                className={clsx(classes.wrapper, (!isTablet && !isDesktop && 'padding') || (isTablet && !isDesktop && classes.tabletPadding))}>
                {!isDesktop &&
                <h4 className={classes.title}>
                    {locationsMenu.title}
                </h4>
                }
                <LocationsContentBar isMenu={true}/>
            </div>
        </div>
    );
}
